import { z } from 'zod';

// The production CSP has no 'unsafe-eval'. Without this, zod probes for eval with
// `new Function`, and the browser reports a CSP violation even though zod catches it.
// main.ts imports this module first, before anything that defines a schema.
z.config({ jitless: true });
